// extracted by mini-css-extract-plugin
module.exports = {"main":"View_main__DGmSL","header_div":"View_header_div__3ZT_g","data_div":"View_data_div__aPcYi"};